export const rollcallleavesummary = [
  {
    id: 1001,
    name: "John Doe",
    leave_type: "SL",
    start_date: "01/08/23",
    end_date: "03/08/23",
    comments: "Recovering from flu",
  },
  {
    id: 1002,
    name: "Jane Smith",
    leave_type: "EL",
    start_date: "10/12/23",
    end_date: "15/12/23",
    comments: "Family vacation in Hawaii",
  },
  {
    id: 1003,
    name: "Michael Johnson",
    leave_type: "CL",
    start_date: "05/07/23",
    end_date: "07/07/23",
    comments: "Personal matters",
  },
  {
    id: 1004,
    name: "Emily Davis",
    leave_type: "OL",
    start_date: "01/10/23",
    end_date: "01/10/23",
    comments: "Observed holiday",
  },
  {
    id: 1005,
    name: "David Wilson",
    leave_type: "SL",
    start_date: "12/09/23",
    end_date: "14/09/23",
    comments: "Sick leave",
  },
  {
    id: 1006,
    name: "Olivia Brown",
    leave_type: "EL",
    start_date: "20/11/23",
    end_date: "24/11/23",
    comments: "Annual leave",
  },
  {
    id: 1007,
    name: "James Miller",
    leave_type: "CL",
    start_date: "15/06/23",
    end_date: "17/06/23",
    comments: "Urgent personal work",
  },
  {
    id: 1008,
    name: "Sophia Moore",
    leave_type: "OL",
    start_date: "25/09/23",
    end_date: "25/09/23",
    comments: "Optional holiday",
  },
  {
    id: 1009,
    name: "Daniel Taylor",
    leave_type: "SL",
    start_date: "20/08/23",
    end_date: "22/08/23",
    comments: "Resting due to illness",
  },
  {
    id: 1010,
    name: "Ava Anderson",
    leave_type: "EL",
    start_date: "01/07/23",
    end_date: "05/07/23",
    comments: "Vacation",
  },
  {
    id: 1011,
    name: "Liam Garcia",
    leave_type: "CL",
    start_date: "10/06/23",
    end_date: "12/06/23",
    comments: "Personal emergency",
  },
  {
    id: 1012,
    name: "Mia Martinez",
    leave_type: "SL",
    start_date: "05/09/23",
    end_date: "07/09/23",
    comments: "Medical recovery",
  },
];
